import { InformationImportance, ModelStatus, OverUseType } from '../enum'

export let ModelListItem = {
  modelId: '',
  taskId: '',
  modelName: '',
  updatedAt: '',
  userName: '',
  statusCode: ModelStatus,
  errorMessage: '',
  algorithmName: '',
  algorithmVersion: '',
  yName: '',
  uploadFileName: '',
  samples: 0,
  type: '',
  password: ''
}

export let InformationItem = {
  title: '',
  description: '',
  importance: InformationImportance
}

export let RemarksItem = {
  overUse: OverUseType
}



// WEBPACK FOOTER //
// ./src/defines/model/list.js